<!-- src/components/Notifications.vue -->
<template>
  <Teleport to="body">
    <Transition name="notification" appear>
      <div
        v-if="notificationStore.isVisible"
        id="Notification"
        class="site__notifications"
        @click="notificationStore.hideNotification"
      >
        <div class="message-box" :class="`message-box-${notificationStore.type}`">
          <i :class="getIconClass"></i>
          <span class="message-text">
            <strong>{{ getTypeCapitalized }}:</strong> {{ notificationStore.message }}
          </span>
          <i class="fi fi-sr-cross" @click.stop="notificationStore.hideNotification"></i>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useNotificationStore } from '@/stores/useNotificationStore'

const notificationStore = useNotificationStore()

const getIconClass = computed(() => {
  const iconMap = {
    success: 'fi fi-ss-check-circle',
    error: 'fi fi-rr-exclamation',
    warning: 'fi fi-sr-triangle-warning',
    info: 'fi fi-sr-info',
  }
  return iconMap[notificationStore.type] || iconMap.info
})

const getTypeCapitalized = computed(() => {
  return notificationStore.type.charAt(0).toUpperCase() + notificationStore.type.slice(1)
})
</script>

<style scoped>
.site__notifications {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  min-width: 300px;
}

.message-box {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 12px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  backdrop-filter: blur(10px);
  color: white;
  font-weight: 500;
  line-height: 1.4;
}

.message-text {
  flex: 1;
}

.message-text strong {
  margin-right: 5px;
}

.fi {
  flex-shrink: 0;
  font-size: 20px;
}

.fi.fi-sr-cross {
  flex-shrink: 0;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.fi.fi-sr-cross:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Notification types */
.message-box-success {
  background: linear-gradient(135deg, #10b981, #059669);
}

.message-box-error {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.message-box-warning {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.message-box-info {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

/* Transitions */
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .site__notifications {
    top: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
    min-width: auto;
  }
}
</style>
